module.exports = __webpack_public_path__ + "img/success.46a69e7f.svg";